export const normalizeLetter = (value) =>
  typeof value === 'string' && value.length === 1 ? value.toLowerCase() : value;

export const formatAnswerValue = (question, value) => {
  if (value === undefined || value === null || value === '') return '—';
  if (question?.type === 'truefalse' || typeof value === 'boolean') {
    return value === true || value === 'true' ? 'Richtig' : 'Falsch';
  }
  if (typeof value === 'number' && question?.options?.[value] !== undefined) {
    return `${String.fromCharCode(97 + value)}) ${question.options[value]}`;
  }
  if (typeof value === 'string' && value.length === 1) {
    return value.toUpperCase();
  }
  return String(value);
};

export const buildQuestionIndex = (tasks) => {
  const map = {};
  let num = 0;
  (tasks || []).forEach((task) => {
    (task.questions || []).forEach((q) => {
      num += 1;
      map[q.id] = { ...q, taskId: task.id, teil: task.teil, displayNum: num };
    });
  });
  return map;
};

export const flattenQuestions = (tasks) => {
  const list = [];
  (tasks || []).forEach((task) => {
    (task.questions || []).forEach((q) => {
      list.push({ ...q, taskId: task.id, teil: task.teil, taskTitle: task.title });
    });
  });
  return list;
};

export const getMatchOptions = (task, q) => {
  if (q.type === 'heading_match') return task.headings || [];
  if (q.type === 'speaker_match') return task.speakers || [];
  return task.texts || [];
};
